import Container from './ForumThread.container';
import Component from './ForumThread';

export default Container(Component);
